import { Subscription } from 'rxjs';
import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ModalController, IonSlides, NavController, ActionSheetController, IonTabs, IonHeader, DomController, IonTabBar } from '@ionic/angular';
import { AirportListComponent } from './../airport-list/airport-list.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AirportListService } from '../../services/airport/airport-list.service';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';

@Component({
  selector: 'app-shopping',
  templateUrl: './shopping.page.html',
  styleUrls: ['./shopping.page.scss'],
})
export class ShoppingPage implements OnInit {
  // @ViewChild('slider') slider: IonSlides;
  // hide header on scroll animation code
  @ViewChild('iontabs') tabs: IonTabs;
  @ViewChild(IonTabBar, { read: ElementRef }) ionTabBarElement: ElementRef;
  private hidden = false;
  private triggerDistance = 15;
  private lastScroll;
  @ViewChild(IonHeader, { read: ElementRef }) element: ElementRef;

  page = '0';
  query = '';
  scrollArea: any;
  scrollSubscribtion: Subscription;
  selectedAirport = '';
  selectedLanguage: string;
  selectedCurrency: string;
  // tslint:disable-next-line: max-line-length
  constructor(
    // hide header on scroll animation code
    private renderer: Renderer2,
    private domCtrl: DomController,

    private modalController: ModalController,
    private router: Router,
    private airportListService: AirportListService,
    private activatedRoute: ActivatedRoute,
    private navControl: NavController,
    private i18ConfigService: I18ConfigService, private actionSheetController: ActionSheetController) {
    this.selectedAirport = this.airportListService.getSelectedAirport();
  }
  ngOnInit() {
    this.selectedLanguage = this.i18ConfigService.getLanguage();
    this.selectedCurrency = this.i18ConfigService.getCurrency();
    this.airportListService.selectedAirport.subscribe(airportCode => {
      this.selectedAirport = airportCode;
    });
    // if (!this.selectedAirport) {
    this.activatedRoute.queryParamMap.subscribe(queryparameters => {
      if (!queryparameters.has('airport')) {
        if (!this.selectedAirport) {
          this.presentModal();
        }
      } else {
        this.airportListService.setSelectedAirport(queryparameters.get('airport'));
      }
    });
    // }
  }

  updateScrollListner() {
    let childComponent = this.tabs.outlet.component;
    if (typeof childComponent !== 'undefined') {
      // tslint:disable-next-line: no-string-literal
      this.scrollArea = childComponent['scrollArea'];
    }
  }

  ionTabchanged() {
    if (this.scrollSubscribtion) {
      this.scrollSubscribtion.unsubscribe();
    }
    this.updateScrollListner();
    this.initStyles();
  }
  ionViewDidEnter() {
    // hide header on scroll animation
    this.updateScrollListner();
    this.initStyles();
  }

  // end of #hide header on scroll animation

  async presentModal() {
    const modal = await this.modalController.create({
      component: AirportListComponent,
      backdropDismiss: false
    });
    return await modal.present();
  }

  filterData(event) {
    if (event.key === 'Enter') {
      this.navControl.navigateForward('shopping/search', { queryParams: { q: event.srcElement.value } });
      // this.router.navigate(['shopping/search'], { queryParams: { q: event.srcElement.value } });
      this.query = '';
    }
  }

  /*   segmentChanged(event) {
    }
   */
  /*   selectedTab(index) {
      this.slider.slideTo(index);
    }
  
    async moveButton() {
      const index = await this.slider.getActiveIndex();
      this.page = index.toString();
    } */
  refreshPage() {
    window.location.reload();
  }

  changeLanguage(value) {
    this.i18ConfigService.setLanguage(value);
    this.selectedLanguage = value;
  }

  async presentCurrencyModal() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Change Currency',
      buttons: [{
        text: 'USD - Dollar',
        // role: 'destructive',
        // icon: 'trash',
        handler: () => {
          this.i18ConfigService.setCurrency('USD');
          this.selectedCurrency = 'USD';
        }
      }, {
        text: 'INR - Rupee',
        // icon: 'share',
        handler: () => {
          this.i18ConfigService.setCurrency('INR');
          this.selectedCurrency = 'INR';
        }
      }, {
        text: 'EUR - Euro',
        // icon: 'arrow-dropright-circle',
        handler: () => {
          this.i18ConfigService.setCurrency('EUR');
          this.selectedCurrency = 'EUR';
        }
      }, {
        text: 'CHF - Swiss Franc',
        // icon: 'heart',
        handler: () => {
          this.i18ConfigService.setCurrency('CHF');
          this.selectedCurrency = 'CHF';
        }
      },{
        text: 'GBP - Pound',
        // icon: 'heart',
        handler: () => {
          this.i18ConfigService.setCurrency('GBP');
          this.selectedCurrency = 'GBP';
        }
      },
       {
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
        }
      }]
    });
    await actionSheet.present();
  }

  async presentLanguageModal() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Change Language',
      buttons: [{
        text: 'EN - English',
        // role: 'destructive',
        // icon: 'trash',
        handler: () => this.changeLanguage('en')
      },
      //  {
      //   text: 'DE - German',
      //   // icon: 'share',
      //   handler: () => this.changeLanguage('de')
      // },
       {
        text: 'Cancel',
        role: 'cancel'
      }]
    });
    await actionSheet.present();
  }



  // hide header on scroll animation

  initStyles() {
    this.scrollSubscribtion = this.scrollArea.ionScroll.subscribe(scrollEvent => {
      let delta = scrollEvent.detail.deltaY;
      if (scrollEvent.detail.currentY === 0 && this.hidden) {
        this.show();
      } else if (!this.hidden && delta > this.triggerDistance) {
        this.hide();
      } else if (this.hidden && delta < -this.triggerDistance) {
        this.show();
      }
    });
    this.domCtrl.write(() => {
      this.renderer.setStyle(
        this.element.nativeElement,
        'transition',
        '0.4s linear'
      );
    });
  }

  hide() {
    this.domCtrl.write(() => {
      this.renderer.setStyle(this.element.nativeElement, 'min-height', '0px');
      this.renderer.setStyle(this.element.nativeElement, 'height', '0px');
      // this.renderer.setStyle(this.element.nativeElement, 'opacity', '0');
      this.renderer.setStyle(this.element.nativeElement, 'padding', '0');
      // setTimeout(() => {
      this.renderer.setStyle(this.element.nativeElement, 'display', 'none');
      // }, 200);
      this.renderer.setStyle(this.ionTabBarElement.nativeElement, 'padding-top', '10px');
    });

    this.hidden = true;
  }

  show() {
    this.domCtrl.write(() => {
      this.renderer.removeStyle(this.element.nativeElement, 'display');
      // setTimeout(() => {
      this.renderer.setStyle(this.element.nativeElement, 'height', '102px');
      // this.renderer.setStyle(this.element.nativeElement, 'opacity', '1');
      this.renderer.removeStyle(this.element.nativeElement, 'min-height');
      this.renderer.setStyle(this.element.nativeElement, 'padding-top', '0px');
      // }, 100);
      // setTimeout(() => {
      this.renderer.removeStyle(this.ionTabBarElement.nativeElement, 'padding');
      // }, 120);
    });

    this.hidden = false;
  }

}
